export default {
  CREATE: `Create a tag`,
  DELETE_BUTTON: {
    TITLE: `Delete the tag`,
    SUMMARY: `Are you sure you want to delete this tag?`,
    PRIMARY_ACTION: `Delete the tag`,
    BAD_MATCH: `The input doesn't match "DELETE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    DELETE: {
      LABEL: `Type "DELETE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Tags list`,
    SUMMARY: ``
  },
  ICON: `Icon`,
  TYPE: `Type`,
  PRONOUN: `Preposition/article`,
  ADDRESS: `Address`,
  AMOUNT: `Amount (Pay)`,
  PREMIUM_TYPE: `Premium type (Pay)`,
  REGIONAL_TAG: `Region`,
  IMPORT_CODE: `Import code`,
  CUSTOM_FIELD_1: `Custom field 1`,
  REGIONALTAGS: `Region`,
  REGIONAL: `Region`,
  WAGEPREMIUMS: `Wage Premium`,
  HOUR: `Hourly`,
  SHIFT: `Per shift`,
  MULTIPLICATOR: `Wage multiplier`,
  LOCATIONS: `Location`,
  CLIENTS: `Client`,
  RESOURCES: `Resource`,
  CUSTOM: `Custom`,
  CUSTOMTAGS: `Custom`,
  WILL_BE_IMPACTED: `The number of resources that will be impacted (deletion or re-assignment)`,
  DELETE_AMOUNT_SHIFT: `Shifts`,
  DELETE_AMOUNT_PROJECTS: `Projects`,
  DELETE_AMOUNT_TEMPLATE: `Templates`,
  DELETE_AMOUNT_TEMPLATE_EVENTS: `Templates events`,
  DELETE_AMOUNT_PUNCH_CARD: `Punch card`,
  DELETE_AMOUNT_USERS: `Users`,
  DELETE_AMOUNT_LOCATIONS: `Locations`,
  CSV_EXPORT_NAME: `tags_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a tag`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a tag`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Tag name`,
      DESCRIPTION: `This name should help you quickly identify the tag.`,
      PLACEHOLDER: `Enter a name for the tag`
    },
    TYPE: {
      LABEL: `Tag type`,
      DESCRIPTION: `Determines whether this tag is a client, location, wage premium, resource or region tag. Some tags can only be assigned to shifts.`
    },
    PRONOUN: {
      LABEL: `Preposition/article`,
      DESCRIPTION: `This will be used when saying the name of the location in the voice interface and for displaying in the application.`
    },
    PREMIUMTYPE: {
      LABEL: `Premium type`,
      DESCRIPTION: `Determines whether this is a shift premium, an hourly premium or a multiplicative premium.`
    },
    AMOUNT: {
      LABEL: `Amount`,
      DESCRIPTION: `Depending on the type of premium, the amount will either be added at a fixed rate, a variable rate depending on the number of hours or multiplied the salary.`,
      PLACEHOLDER: `Enter the amount of the premium.`
    },
    CUSTOMFIELD1: {
      LABEL: `Custom field 1`,
      DESCRIPTION: `The field is used with some integrations.`,
      PLACEHOLDER: `Enter a value for the custom field`
    },
    REGIONALTAG: {
      LABEL: `Region`,
      DESCRIPTION: `Select the region of the location.`
    },
    IMPORTCODE: {
      LABEL: `Import code`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: `This will be used in the import tools to assign tags to users.`
    },
    ADDRESS: {
      ROOM: {
        LABEL: `Room/Apartment`,
        PLACEHOLDER: `Enter the room or apartment number`,
        DESCRIPTION: ``
      },
      FLOOR: {
        LABEL: `Floor`,
        PLACEHOLDER: `Enter the floor`,
        DESCRIPTION: ``
      },
      STREET_NUMBER: {
        LABEL: `Street number`,
        PLACEHOLDER: `Enter the street number`,
        DESCRIPTION: ``
      },
      ROUTE: {
        LABEL: `Street address`,
        PLACEHOLDER: `Enter the street address`,
        DESCRIPTION: ``
      },
      LOCALITY: {
        LABEL: `City`,
        PLACEHOLDER: `Enter the city`,
        DESCRIPTION: ``
      },
      ADMINISTRATIVE_AREA_LEVEL_1: {
        LABEL: `Province/State`,
        PLACEHOLDER: `Enter the province/state`,
        DESCRIPTION: ``
      },
      POSTAL_CODE: {
        LABEL: `Postal Code`,
        PLACEHOLDER: `Enter the postal code`,
        DESCRIPTION: ``
      },
      COUNTRY: {
        LABEL: `Country`,
        PLACEHOLDER: `Enter the country`,
        DESCRIPTION: ``
      }
    },
    NAME_REQUIRED: `Tag's name is mandatory.`,
    TYPE_REQUIRED: `Tag's duration is mandatory.`,
    SHOWINEMPLOYEESCHEDULE: {
      LABEL: `Show on employee Schedule`,
      DESCRIPTION: `Determines whether this tag should be displayed on the employee schedule.`
    }
  }
}
